import React from "react";
import { Formik, Form } from "formik";
import styles from "./AgentsCategoriesDetails.module.scss";
import AgentsCategoriesSchema from "./validation";
import { observer } from "mobx-react";
import { getSnapshot } from "mobx-state-tree";
import { TextArea, Classes } from "@blueprintjs/core";
import { AgentsCategoriesType, fields } from "modules/dictionaries/agents-categories/models/agents-categories";
import { fixTextAreaHeight, MODAL_AWAIT_DELAY } from "modules/common/services/form/textarea";
import { StandardFormInput } from "modules/common/components/form/StandardFormInput";
import { Schema } from "yup";
import { StandardFormButtons } from "modules/common/components/form/StandardFormButtons";
import { texts } from "modules/common/texts";
import { Prompt } from "modules/common/components/routing/Prompt";

class AgentsCategoriesDetailsBase extends React.PureComponent<AgentsCategoriesDetailsProps, AgentsCategoriesState> {
  private schema: Schema<any>;
  private commentArea: HTMLTextAreaElement | null = null;
  private nameArea: HTMLTextAreaElement | null = null;

  constructor(props: AgentsCategoriesDetailsProps) {
    super(props);

    this.schema = AgentsCategoriesSchema();

    this.state = {
      isMobile: window.innerWidth < 885,
    };
  }

  handleResize = () => {
    if (window.innerWidth < 885) {
      this.setState({ isMobile: true });
    } else {
      this.setState({ isMobile: false });
    }
  };

  private commentAreaRef = (ref: HTMLTextAreaElement | null) => {
    this.commentArea = ref;
  };

  private nameAreaRef = (ref: HTMLTextAreaElement | null) => {
    this.nameArea = ref;
  };

  private resize = () => {
    fixTextAreaHeight(this.commentArea);
    fixTextAreaHeight(this.nameArea);
  };

  public componentDidMount() {
    window.addEventListener("resize", this.handleResize);
    setTimeout(this.resize, MODAL_AWAIT_DELAY);
  }

  public componentDidUpdate() {
    this.resize();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  render() {
    const { schema, props } = this;
    const { agentsCategories, onSaved, onRemoved, canChange } = props;
    const isMobile = this.state.isMobile;

    return (
      <div className={styles.details}>
        <Formik
          initialValues={getFormValues(agentsCategories)}
          enableReinitialize={true}
          validationSchema={schema}
          onSubmit={async (values, { setSubmitting, resetForm }) => {
            if (!canChange) {
              return;
            }

            const succsessfull = await agentsCategories.save(values);
            setSubmitting(false);

            if (succsessfull) {
              resetForm();
              onSaved();
            }
          }}
        >
          {(formProps) => {
            const onRemove = async () => {
              if (!canChange) {
                return;
              }

              formProps.setSubmitting(true);
              const success = await agentsCategories.delete();
              formProps.setSubmitting(false);
              success && onRemoved();
            };

            return (
              <Form autoComplete="off">
                <Prompt when={formProps.dirty && canChange} message={texts.messages.leaveConfiramtion} />
                <div className={Classes.DIALOG_BODY}>
                  <StandardFormInput
                    name={fields.name}
                    schema={schema}
                    small={true}
                    inline={!isMobile}
                    className="planr-form-input"
                  >
                    {({ field }) => (
                      <div className={`${Classes.INPUT_GROUP} planr-default-input`}>
                        <TextArea
                          id={field.name}
                          {...field}
                          growVertically={true}
                          className={Classes.FILL}
                          inputRef={this.nameAreaRef}
                          disabled={!canChange}
                        />
                      </div>
                    )}
                  </StandardFormInput>

                  <StandardFormInput
                    inline={!isMobile}
                    name={fields.description}
                    schema={schema}
                    small={true}
                    className="planr-form-input"
                  >
                    {({ field }) => (
                      <div className={`${Classes.INPUT_GROUP} planr-default-input`}>
                        <TextArea
                          id={field.name}
                          {...field}
                          growVertically={true}
                          className={Classes.FILL}
                          inputRef={this.commentAreaRef}
                          disabled={!canChange}
                        />
                      </div>
                    )}
                  </StandardFormInput>
                </div>
                <div className={Classes.DIALOG_FOOTER}>
                  {canChange && (
                    <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                      <StandardFormButtons
                        {...formProps}
                        isRemoved={false}
                        what={`ИРД ${agentsCategories.name}`}
                        isNewlyCreated={agentsCategories.isNewlyCreated}
                        onRemove={onRemove}
                      />
                    </div>
                  )}
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    );
  }
}

export const AgentsCategoriesDetails = observer(AgentsCategoriesDetailsBase);

interface AgentsCategoriesDetailsProps {
  agentsCategories: AgentsCategoriesType;
  onSaved: () => void;
  onRemoved: () => void;
  canChange: boolean;
}

interface AgentsCategoriesState {
  isMobile: boolean;
}

function getFormValues(agentsCategories: AgentsCategoriesType) {
  return {
    ...getSnapshot(agentsCategories),
  };
}
